import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  Council,
  ProfileProviderPF,
} from '../../../../core/generated';
import { CouncilControllerService } from '../../../../core/generated/api/councilController.service';

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MaterialModule } from '../../../../shared/material/material.module';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DialogCouncilFormComponent } from './dialog-council-form.component';
import { CouncilProfessionComponent } from './councilProfession/council-profession.component';

@Component({
    selector: 'app-council',
    standalone: true,
    imports: [MaterialModule, CouncilProfessionComponent],
    templateUrl: './council.component.html',
    styleUrl: './council.component.scss',
    animations: [
        trigger('detailExpand', [
            state('collapsed,void', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CouncilComponent implements OnInit {
  private councilService = inject(CouncilControllerService);
  private cd = inject(ChangeDetectorRef);
  public dialog = inject(MatDialog);
  deviceService = inject(DeviceDetectorService);
  isMobile = this.deviceService.isMobile();
  @Input() profileProviderPFId!: number;
  @Input() profileProviderPF!: ProfileProviderPF;
  @Output() hasAnyProfileCouncil: EventEmitter<any> = new EventEmitter();
  @ViewChild(MatTable) table!: MatTable<Council>;
  councils: Council[] = [];
  displayedColumnsCouncils: string[] = [
    'certifiedHubMedical',
    'councilGroup',
    'councilInscriptionNumber',
    'district',
    'expand',
  ];

  expandedElement: Council | null = null;


  ngOnInit() {
    this.loadCouncils();
  }

  loadCouncils() {
    this.councilService.findAllByProfileProviderPFId(this.profileProviderPFId).subscribe((councilList) => {
      this.councils = councilList;
      this.cd.detectChanges();
    });
  }

  async deleteCouncil(councilId: number) {
    await this.councilService.deleteById14(councilId).subscribe();
    this.councils = this.councils.filter((item) => item.id != councilId);
  }

  createCouncil(council: Council | null) {
    const dialogRef = this.dialog.open(DialogCouncilFormComponent, {
      data: { council: council, profileProviderPF: this.profileProviderPF },
    });

    dialogRef.afterClosed().subscribe((result: Council) => {
      if (result && result.id) {
        this.councils.push(result);
        this.table.renderRows();
        this.cd.detectChanges();
      }
    });
  }

  editCouncil(council: Council) {
    const dialogRef = this.dialog.open(DialogCouncilFormComponent, {
      data: { council: council },
    });

    dialogRef.afterClosed().subscribe((result: Council) => {
      if (result.id) {
        this.councils = this.councils.filter((item) => item.id != result.id);

        this.councils.push(result);
        this.table.renderRows();
        this.cd.detectChanges();
      }
    });
  }
}
